import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SURVEY_ANSWER_TYPES_ENTITY_TYPE,
  SURVEY_ANSWER_TYPES_LOADING_TYPE,
  SURVEY_ANSWER_SUB_TYPES_ENTITY_TYPE,
  SURVEY_ANSWER_SUB_TYPES_LOADING_TYPE,
  SURVEY_ARTICLES,
  SURVEY_ARTICLES_LOADING,

  SURVEY_DYNAMIC_OPERATORS_ENTITY_TYPE,
  SURVEY_DYNAMIC_OPERATORS_TYPES_LOADING_TYPE
} from "./constants";
import { IDynamicOperators, IState, ISurveyAnswerSubTypes, ISurveyAnswerTypes, ISurveyArticles, ISurveyVersions, ITaskTypes } from "./_interfaces";


const initialState:IState = {
  ...defaultInitialState,
  surveysVersions: [],

  surveyTaskTypesLoading: false,
  taskTypes: [],

  [SURVEY_DYNAMIC_OPERATORS_TYPES_LOADING_TYPE]: false,
  [SURVEY_DYNAMIC_OPERATORS_ENTITY_TYPE]: [],

  [SURVEY_ANSWER_TYPES_ENTITY_TYPE]: [],
  [SURVEY_ANSWER_TYPES_LOADING_TYPE]: false,

  [SURVEY_ANSWER_SUB_TYPES_LOADING_TYPE]: false,
  [SURVEY_ANSWER_SUB_TYPES_ENTITY_TYPE]: [],





  [SURVEY_ARTICLES]: [],
  [SURVEY_ARTICLES_LOADING]: []
};

const reducers = {
  ...defaultReducers,
  surveysVersions: (state:IState, action:PayloadAction<ISurveyVersions[]>) => {
    state.error = null;
    state.surveysVersions = action.payload;
  },

  setTaskTypesLoading: (state:IState, action:PayloadAction<boolean>) => {
    state.surveyTaskTypesLoading= action.payload;
  },
  setTaskTypes: (state:IState, action:PayloadAction<ITaskTypes[]>) => {
    state.error = null;
    state.taskTypes = action.payload;
  },

  surveyDynamicOperatorsLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[SURVEY_DYNAMIC_OPERATORS_TYPES_LOADING_TYPE] = action.payload
  },
  surveyDynamicOperators: (state:IState, action:PayloadAction<IDynamicOperators[]>) => {
    state.error = null;
    state[SURVEY_DYNAMIC_OPERATORS_ENTITY_TYPE] = action.payload;
  },

  surveyAnswerTypesFetchedLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[SURVEY_ANSWER_TYPES_LOADING_TYPE] = action.payload;
  },
  surveyAnswerTypesFetched: (state:IState, action:PayloadAction<ISurveyAnswerTypes[]>) => {
    state.error = null;
    state[SURVEY_ANSWER_TYPES_ENTITY_TYPE] = action.payload;
  },

  surveyAnswerSubTypesFetchedLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[SURVEY_ANSWER_SUB_TYPES_LOADING_TYPE] = action.payload;
  },
  surveyAnswerSubTypesFetched: (state:IState, action:PayloadAction<ISurveyAnswerSubTypes[]>) => {
    state.error = null;
    state[SURVEY_ANSWER_SUB_TYPES_ENTITY_TYPE] = action.payload;
  },
  surveyArticlesLoading: (state:IState, action:PayloadAction<{qIndex: number, value: boolean}>) => {
    state[SURVEY_ARTICLES_LOADING][action.payload.qIndex] = action.payload.value;
  },
  surveyArticlesFetched: (state:IState, action:PayloadAction<{qIndex: number, list:ISurveyArticles[]}>) => {
    state.error = null;
    state[SURVEY_ARTICLES][action.payload.qIndex] = action.payload.list; //TODO: 
  },
};

export const surveysSlice = createSlice({
  name: "surveys",
  initialState,
  reducers,
});

